import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Stock markets collapsing - buy buy buy buy!",
  "description": "",
  "published": "2008-09-18T00:00:00.000Z",
  "redirect_from": ["/blog/stock-markets-collapsing-buy-buy-buy-buy/swizec/69"],
  "categories": "food for thought, life",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`For the past few days we've been hearing worldwide reports of stock market panic, everything is collapsing, stock values are plummeting like stones and everyone is afraid of another crisis like there was in the 70's or even worse, like there was in the 20's. That would be quite bad wouldn't it?`}</p>
    <p>{`But I'm certain it won't come to that, at least not to the kind there was in the 20's because there are too many rich places in the world right now, markets are more flexible and there's probably a whole bunch of reasons why we won't see another total collapse as we did back then. This is why everyone should BUY. If you have any money, any money at all, buy stocks, just do it, BUY NOW!`}</p>
    <p>{`Yes, there is one anecdotal story of a very rich person coming up to a regular bloke who didn't recognise him and said "Dude, you should totally invest in the stock market, everyone's doing it and it will make you rich". The rich person sold all stock the very next day because when everyone is doing something there is something wrong. What happened? Black Friday happened next week.`}</p>
    <p>{`Right now, however, everyone is telling you to sell if you want to keep your money. You should, however, buy. Buy because it's cheap and WILL regain price soon, very soon in fact. It doesn't even matter whether it rises in value in a week, a year or even a decade, what matters is that you'll have huge profits, possibly even doubling your money.`}</p>
    <p>{`Now if you'll excuse me I have to go figure out how I could scrunge up the money to invest.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      